import React from "react";
import { IonButton, IonImg } from "@ionic/react";
import DOMPurify from 'isomorphic-dompurify';
interface EmptyListComponentProps {
  icon: string;
  message: string;
  callback: any;
  constantButton: string;
}

const EmptyListComponent:React.FC<any> = (props: EmptyListComponentProps) => {
  function createMarkup(content : any) {
    const clean = DOMPurify.sanitize(content);
    return {__html: clean};
  }
    return (
      <div className="No-Recommended">
        <img
          alt="logo"
          src={`assets/icon/${props.icon}.svg`}
          width="79.01px"
          height="84.59px"
        />
        <p className="recommended-Error"  dangerouslySetInnerHTML={createMarkup(props.message)}>
        </p>
        <div className="SearchLoadBtn">
          <IonButton
            expand="full"
            shape="round"
            onClick={props.callback}
            size="large"
            type="submit"
            class="RecommendedSearch"
          >
            <IonImg src="assets/icon/add.svg" class="load-search" />
            {props.constantButton}
          </IonButton>
        </div>
      </div>
    );
}

export default EmptyListComponent;
